class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/switches-bulk-validate`;
    }
    /**
     * Validates switches before creation or update. The maximum number
     * of switches per request is 10 000.
     *
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/emergency-address-auto-update/switches-bulk-validate
     * Rate Limit Group: Heavy
     * App Permission: EditAccounts
     * User Permission: ConfigureEmergencyMaps
     */
    async post(validateMultipleSwitchesRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), validateMultipleSwitchesRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
